export const navItems = [
  {
    id: 1,
    title: "Home",
    linkTo: "/",
  },
  {
    id: 2,
    title: "Men",
    linkTo: "/men",
  },
  {
    id: 3,
    title: "Women",
    linkTo: "/women",
  },
  {
    id: 4,
    title: "Kids",
    linkTo: "/kids",
  },
  {
    id: 5,
    title: "Contact",
    linkTo: "/contact",
  },
];
